import { useWSModal } from "@wingspanhq/fe-component-library";
import { ModalShareInformationWithClient } from "./index";

export const useModalShareInformationWithClient = () =>
  useWSModal(ModalShareInformationWithClient, {
    size: "S",
    title: "Share information with client"
  });
